// ============================================
// モジュール読み込み
// ============================================
import { viewport } from './libs/switchViewport';
import { blackBgAnim, footerParallax, inViewAnm, lenisPageScroll, mvFeather, pictureAnim } from './libs/Scroll';
import { drawer, fixedHeader, navSplit } from './libs/Header';
import { addAutoFunc, numKeyFunc } from './libs/Form';
import { mouseWebGLAction } from './libs/MouseWebGLAction';
import { curtain } from './libs/Curtain';
import { Post } from './libs/Post';
import { slider } from './libs/Slider';

// 実行
// ==========================
window.addEventListener('DOMContentLoaded', () => {
  viewport();
  fixedHeader();
  navSplit();
  drawer();
  addAutoFunc();
  numKeyFunc();
  lenisPageScroll();
  curtain();
});

window.addEventListener('load', () => {
  document.body.classList.add('is-loaded');
  mouseWebGLAction();
  blackBgAnim();
  slider();
  pictureAnim();
  mvFeather();
  inViewAnm();
  Post();
  footerParallax();
});
